import {IUser} from './database';
import {Role} from './role.model';
import {Permission} from './permission.model';
import {BaseModel} from './base.model';
import {UserDomainDetails} from './user-domain.model';


export class User extends BaseModel<IUser> implements IUser {
  created_at: Date | null;
  deleted_at: Date | null;
  email: string;
  id: number;
  is_password_temporary: any;
  name: string;
  password: string;
  role_id: number;
  superadmin: string | null;
  updated_at: Date | null;
  manager_id: number | null;
  phone: string;
  photo: any;

  impersonated_by: User;
  role: Role;
  permissions?: Permission[];

  domains: UserDomainDetails[] = [];
  role_name?: string;


  constructor(data: User) {
    super(data);
    if (data.impersonated_by) {
      this.impersonated_by = new User(data.impersonated_by);
    }
    this.role = new Role(this.role);
    if (this.permissions) {
      this.permissions = this.permissions.map(p => new Permission(p));
    }
    if (data.hasOwnProperty('domains')) {
      this.domains = data.domains.map(d => new UserDomainDetails(d));
    }
  }

  public photoUrl(): string {
    if (this.photo === null) {
      return 'assets/images/profile.png';
    }
    return this.photo;
  }

  public can(...permissions: string[]): boolean {
    if (!this.permissions || this.permissions.length === 0) {
      return false;
    }

    for (const checkPermission of permissions) {
      const permissionFound = this.permissions.find(x => x.name === checkPermission);

      if (!permissionFound) {
        return false;
      }
    }
    return true;
  }

  public any(...permissions: string[]): boolean {
    if (!this.permissions || this.permissions.length === 0) {
      return false;
    }

    for (const checkPermission of permissions) {
      const permissionFound = this.permissions.find(x => x.name === checkPermission);

      if (permissionFound) {
        return true;
      }
    }
    return false;
  }
}
